'use client';

import { Box, Flex } from "@chakra-ui/react";
import Container from '@/components/partials/Container';
import { LuMenu, LuEllipsisVertical } from "react-icons/lu"
import Live from "./Live"
import Logo from "./Logo"
import NavMenu from "./NavMenu"
import Search from "./Search"
import ColorMenu from "./ColorMenu"
import ResponsiveMenu from "./ResponsiveMenu"
import { useState } from "react";

export default function BaseMenu({ navmenu, colormenu }) {
  const [openedMenu, setOpenedMenu] = useState(false);

  function handleMenuToggle() {
    setOpenedMenu(!openedMenu);
  };

  const mobileHidden = { base: 'none', xl: 'block' };
  const mobileShow = { base: 'block', xl: 'none' };

  return (
    <Container>
      <Flex justifyContent={{ base: 'space-between', sm: 'space-between' }} alignItems={{ base: 'center', xl: 'end' }} >
        <Flex w="100%" justifyContent={{ base: 'space-between', lg: 'space-between' }} alignItems="center" h={{ base: '110px', lg: '100px' }}>
          <Box w="100%" maxW={{ base: '170px', md: '200px' }}>
            <Logo />
          </Box>

          <Box display={mobileHidden}>
            <NavMenu menu={navmenu} />
          </Box>

          <Box display={mobileHidden}>
            <Search />
          </Box>
        </Flex>

        <Box display={mobileHidden}>
          <ColorMenu menu={colormenu} />
        </Box>

        <Box display={mobileShow} fontSize="2.4em" cursor="pointer" onClick={() => handleMenuToggle()}>
          { openedMenu ? <LuEllipsisVertical /> : <LuMenu /> }
        </Box>
      </Flex>

      <Box>
        <ResponsiveMenu menu={[...navmenu, ...colormenu]} openedMenu={openedMenu} handleMenuToggle={handleMenuToggle} />
      </Box>
    </Container>
  )
}
